import React, { FC, useEffect, useState } from 'react';
import './DeviceCards.css';
import DevicePriceWrapper from '../DevicePriceWrapper/DevicePriceWrapper';
import { fetchCustomPageDeviceGroup } from '../../../services/DeviceService';
import { getDeviceSlugPath } from '../../../utils/DeviceUtils';
import { getElementMaximumHeight } from '../../../utils/utils';

const DeviceCards: FC<any> = ({
  cardData,
  cardIndex,
  content,
  sbDeviceConstantKeys,
}): any => {
  const [hardWareObj, setHardWareObj] = useState<any>();
  const [smartbadgeWidth, smartsetbadgeWidth] = useState<number>(0);
  const [cardLink, setCardLink] = useState('');
  // to get the width of the first badge
  const getBadgeWidth = () => {
    const ele = document.getElementById(`custDeviceBadge${cardIndex}0`);
    ele?.clientWidth && smartsetbadgeWidth(ele?.clientWidth);
  };
  useEffect(() => {
    const fetchData = async () => {
      let dataresp: any = await fetchCustomPageDeviceGroup(
        cardData,
        content?.pageType
      );
      setHardWareObj(dataresp);
    };
    fetchData();
  }, []);

  useEffect(() => {
    setCardLink(getDeviceSlugPath(cardData?.m_p_id, cardData));
    const badge = document.getElementById(`custDeviceBadge${cardIndex}0`);
    if (badge && badge?.clientHeight >= 40) {
      badge.style.top = '-36px';
    }
    findHeight();
    window.addEventListener('resize', findHeight);
    getBadgeWidth();
  }, [hardWareObj]);

  const findHeight = () => {
    getElementMaximumHeight(
      'custDeviceHeading',
      content?.devicePreviewCardList?.length
    );
    getElementMaximumHeight(`custDeviceBadge${cardIndex}`, 2);
  };
  return (
    <>
      <div className='custDeviceCardPreview'>
        <a href={cardLink} className='custDeviceCardWrapper'>
          <div className='position-relative'>
            {/* smartUpgrade badge */}
            {hardWareObj?.smartUpgradeInstallments?.discount?.value && (
              <div
                id={`custDeviceBadge${cardIndex}0`}
                className={`d-flex custDeviceFirstBadge custDeviceWithoutDiscount`}
              >
                <div>{sbDeviceConstantKeys?.dp_smartupgrade}</div>
              </div>
            )}
            {/* promo badge */}
            {hardWareObj?.dPSubsidyPromotion?.discountedRatePlan && (
              // badge
              <div
                id={`custDeviceBadge${cardIndex}1`}
                className={`d-flex custDeviceFirstBadge custDeviceWithDiscount ${
                  hardWareObj?.smartUpgradeInstallments?.discount?.value &&
                  'custDeviceSecondBadge'
                }
          }`}
                style={{
                  left: `${smartbadgeWidth ? smartbadgeWidth + 33 : 24}px`,
                }}
              >
                <div
                  className={`d-flex align-items-center custDeviceBadgeIcon`}
                >
                  <img
                    src={sbDeviceConstantKeys?.dp_promo_icon}
                    width={24}
                    height={24}
                    alt='5G-icon'
                  />
                </div>
                <div>
                  {`-${+hardWareObj?.dPSubsidyPromotion?.discount?.value} ${
                    sbDeviceConstantKeys?.dd_discount
                  }`}
                </div>
              </div>
            )}
            <div className='custDeviceCards'>
              <div
                className='d-flex custDeviceHeading'
                id={`custDeviceHeading${cardIndex}`}
              >
                <div className='custDeviceTitle'>
                  <div>{cardData?.displayText}</div>
                  <div className='custDeviceSubTitle'></div>
                </div>
                <div className='d-flex align-items-center ms-auto mb-auto'>
                  <img
                    src={content?.fiveGIcon?.filename}
                    width={24}
                    height={24}
                  />
                </div>
              </div>
              <div className='custDeviceLine'></div>
              <div className='custDeviceImage'>
                <img src={`${cardData?.images?.[0]?.filename}/m/`} />
              </div>
              <div className='custDevicePriceContainer'>
                <DevicePriceWrapper
                  getDeviceID={cardData?.m_p_id}
                  priceContent={hardWareObj}
                  cardIndex={cardIndex}
                  totalLength={content?.devicePreviewCardList?.length}
                  proceedButtonIcon={content?.proceedButtonIcon?.filename}
                  sbDeviceConstantKeys={sbDeviceConstantKeys}
                />
              </div>
            </div>
          </div>
        </a>
      </div>
    </>
  );
};

export default DeviceCards;
